<div>
    <p>{{value}}%</p>
    <mat-progress-bar mode="determinate" [value]="value"></mat-progress-bar>
</div>